import { MONO, WORD } from "./logoPaths";

export const Monogram = ({ className = "h-11 w-11", textClass = "" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false">
    <path d={MONO.arch} fill="none" stroke="currentColor" strokeWidth="2.2" />
    <path d={MONO.archInner} fill="none" stroke="currentColor" strokeWidth="0.8" opacity="0.6" />
    <path d={MONO.base} stroke="currentColor" strokeWidth="2.2" />
    <path d={MONO.key} fill="currentColor" />
    <path d={MONO.text} fill="currentColor" className={textClass} />
  </svg>
);

export const Logo = ({ tone = "light", tagline = false, className = "h-12" }) => {
  const mark = tone === "light" ? "#C5A059" : "#9A7634";
  const ink = tone === "light" ? "#FAF8F5" : "#0F1E36";
  return (
    <span className="inline-flex flex-col" data-testid="brand-logo">
      <svg viewBox={`0 0 ${WORD.width} 64`} className={`${className} w-auto`} role="img" aria-label="MSK Hotels">
        <g style={{ color: mark }}>
          <path d={MONO.arch} fill="none" stroke="currentColor" strokeWidth="2.2" />
          <path d={MONO.archInner} fill="none" stroke="currentColor" strokeWidth="0.8" opacity="0.6" />
          <path d={MONO.base} stroke="currentColor" strokeWidth="2.2" />
          <path d={MONO.key} fill="currentColor" />
          <path d={MONO.text} fill="currentColor" />
        </g>
        <path d={WORD.msk} fill={ink} />
        <path d={WORD.sub} fill={ink} opacity="0.85" />
      </svg>
      {tagline && <span className="mt-3 font-display text-base italic text-gold">All In, On Site</span>}
    </span>
  );
};
